import React, { useState } from 'react';
import { Button, Modal, Col, Form, Row } from 'react-bootstrap';
import toast, { Toaster } from 'react-hot-toast';
import { useForm } from 'react-hook-form';
import { useFirebase } from '../../../contexts/FirebaseContext';

const DeleteTrack = () => {
  const [showDeleteTrack, setShowDeleteTrack] = useState(false);
  const { deleteTrack } = useFirebase();

  const { register, reset, handleSubmit } = useForm();

  const onSubmit = async (data) => {
    await deleteTrack(data.track)
      .then(reset())
      .then(() => {
        toast.success(`${data.track} has been deleted!`, {
          duration: 2000,
          icon: '👏',
        });
      })
      .then(
        setTimeout(() => {
          window.location.reload();
        }, 2000)
      )
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          className='btn-danger ml-2 mt-2 mb-2'
          onClick={() => setShowDeleteTrack(true)}
        >
          Delete Track
        </Button>
      </div>

      <Modal
        size='md'
        data-backdrop='static'
        data-keyboard='false'
        animation={true}
        show={showDeleteTrack}
        onHide={() => setShowDeleteTrack(!showDeleteTrack)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Track</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col>
                {/* Track */}
                <Form.Label>Track</Form.Label>
                <Form.Group controlId='formDeleteTrack'>
                  <Form.Control
                    type='text'
                    name='track'
                    placeholder='What track?'
                    ref={register({ required: true })}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Button className='w-25' variant='danger' type='submit'>
                  Delete
                </Button>
                <Toaster />
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DeleteTrack;
